











































































import { Component, Prop } from 'vue-property-decorator';
import FormRow from '@/components/common/forms/FormRow.vue';
import FormInput from '@/components/common/forms/FormInput.vue';
import FormError from '@/components/common/forms/FormError.vue';
import { FivGoalModel, GoalValueType } from 'admiral-core';
import FormTextarea from '@/components/common/forms/FormTextarea.vue';
import { CheckIcon, CopyIcon, PlusIcon } from 'vue-feather-icons';
import FormDateInput from '@/components/common/forms/FormDateInput.vue';
import AgencyStatusSelect from '@/components/common/selects/AgencyStatusSelect.vue';
import ProductSelect from '@/components/common/selects/ProductSelect.vue';
import { mixins } from 'vue-class-component';
import { BaseMixin } from '@/mixins/BaseMixin';

@Component({
  components: {
    ProductSelect,
    AgencyStatusSelect,
    FormDateInput,
    FormTextarea,
    FormError,
    FormInput,
    FormRow,
    PlusIcon,
    CopyIcon,
    CheckIcon,
  },
})
export default class FivGoalForm extends mixins(BaseMixin) {
  @Prop({ required: true, type: Object })
  readonly value!: FivGoalModel;

  @Prop({ required: true, type: Object })
  readonly errors!: FivGoalModel;

  async mounted() {
    //
  }

  onInput(key: string, value: any) {
    this.$emit('input', { ...this.value, [key]: value });
  }

  onErrorReset(key: string) {
    this.$emit('reset-error', key);
  }

  get isValueType() {
    return this.value.valueType === GoalValueType.Valuation;
  }

  get isQuantityType() {
    return this.value.valueType === GoalValueType.Quantity;
  }
  async selectAllProducts() {
    await this.$store.dispatch('DataModule/fetchProducts', {
      agency: this.user.agency,
    });
    this.onInput('products', this.products);
  }

  clearAllProducts() {
    this.onInput('products', []);
  }
}
